import Loader from "./Loader";

interface FetchMoreProps {
  fetchMoreRef: (node?: Element | null | undefined) => void;
  isFetchingMore?: boolean;
}

function FetchMore({ fetchMoreRef, isFetchingMore = false }: FetchMoreProps) {
  return (
    <div ref={fetchMoreRef} className="h-20 w-full">
      {isFetchingMore && <Loader />}
    </div>
  );
}

export default FetchMore;
